/**
 * Object-URL helpers for PRE-COMMIT photo thumbnails (the capture screens).
 *
 * Extracted 2026-07-27 when text capture turned out to show a photo COUNT but no
 * thumbnail, while voice capture showed both — you added a photo and got a bare
 * number back, the same "did that actually work?" ambiguity the SaveScreen
 * thumbnail was added to remove.
 *
 * Shared here rather than per-component because the guards are the load-bearing
 * part and they are easy to get subtly wrong: `URL.createObjectURL` is absent in
 * jsdom, and `revokeObjectURL` can be gone at unmount (torn-down stub), so an
 * unguarded revoke throws during cleanup. A missing API degrades to
 * no-thumbnail; it must never throw on the capture path.
 *
 * NOTE these are for blobs held IN MEMORY before commit. Committed rows read
 * their photos from IndexedDB via CaptureThumbs — that component returns null
 * pre-commit by design, so it cannot be used on a capture screen.
 */

/** Object-URL for a photo thumbnail, or null when the API is unavailable. */
export function makeThumbUrl(file: Blob): string | null {
  if (typeof URL === "undefined" || typeof URL.createObjectURL !== "function") return null;
  return URL.createObjectURL(file);
}

/** Release a thumbnail URL. Safe to call when the API is already gone. */
export function revokeThumbUrl(url: string): void {
  if (typeof URL !== "undefined" && typeof URL.revokeObjectURL === "function") URL.revokeObjectURL(url);
}
